import { defineAction } from '~/prix'
import { z } from 'zod'
import residenceDocumentDeleteAction from './residenceDocumentDelete.action.json' with { type: 'json' }
import { residenceDocumentObject } from '../residenceDocumentObject'

const residenceDocumentDeleteDefinition = defineAction({
  ...residenceDocumentDeleteAction,

  input: z.object({ id: residenceDocumentObject.shape.id }),
  output: z.object({}),
})

export default residenceDocumentDeleteDefinition
